var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14C7.9 14 6.95833 13.6083 6.175 12.825C5.39167 12.0417 5 11.1 5 10V4C5 2.9 5.39167 1.95833 6.175 1.175C6.95833 0.391667 7.9 0 9 0C10.1 0 11.0417 0.391667 11.825 1.175C12.6083 1.95833 13 2.9 13 4V10C13 11.1 12.6083 12.0417 11.825 12.825C11.0417 13.6083 10.1 14 9 14ZM7 22V18.85C4.96667 18.6167 3.29167 17.7333 1.975 16.2C0.658333 14.6667 0 12.8833 0 10.85H2C2 12.7833 2.68333 14.425 4.05 15.775C5.41667 17.125 7.06667 17.8 9 17.8C10.9333 17.8 12.5833 17.125 13.95 15.775C15.3167 14.425 16 12.7833 16 10.85H18C18 12.8833 17.3417 14.6667 16.025 16.2C14.7083 17.7333 13.0333 18.6167 11 18.85V22H7ZM9 12C9.55 12 10.0208 11.8042 10.4125 11.4125C10.8042 11.0208 11 10.55 11 10V4C11 3.45 10.8042 2.97917 10.4125 2.5875C10.0208 2.19583 9.55 2 9 2C8.45 2 7.97917 2.19583 7.5875 2.5875C7.19583 2.97917 7 3.45 7 4V10C7 10.55 7.19583 11.0208 7.5875 11.4125C7.97917 11.8042 8.45 12 9 12Z",
    fill: "#0E1C2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.dfb913dfce0a8052803b1567905b02cb.svg";
export { ForwardRef as ReactComponent };